////////////////////////////////////////////////////////////////////////////////
//
//
// (C) Copyright 2023 Autodesk, Inc. All rights reserved.
//
//                      ****  CONFIDENTIAL MATERIAL  ****
//
// The information contained herein is confidential, proprietary to
// Autodesk, Inc., and considered a trade secret.  Use of this information
// by anyone other than authorized employees of Autodesk, Inc. is granted
// only under a written nondisclosure agreement, expressly prescribing the
// the scope and manner of such use.
//
////////////////////////////////////////////////////////////////////////////////

import {AvtJobDataEntry, JobRunItemStatusType, UsageSortType} from '../../clients/Classes';

export class JobsState {
  public dataItems: AvtJobDataEntry[];
  public customerIds: string[];
  public userIds: string[];
  public jobIds: string[];
  public jobRunIds: string[];
  public statuses: JobRunItemStatusType[];
  public startDate: Date | null = null;
  public useStartDate: boolean;
  public endDate: Date | null = null;
  public useEndDate: boolean;
  public sortingField: UsageSortType = UsageSortType.Date;
  public sortAscending: boolean;
  public loading = false;
  public loadingCsv = false;
  public loadingMoreData = false;
  public hasMoreData = false;

  public showDetail = false;
  public detailObject: AvtJobDataEntry | undefined;
  public truncateDetailStrings = true;

  constructor() {
    this.statuses = [];
    this.jobIds = [];
    this.jobRunIds = [];
    this.customerIds = [];
    this.userIds = [];
    this.dataItems = [];
    this.useStartDate = false;
    this.useEndDate = false;
    this.sortAscending = false;
  }
}
